export const shoppingPl = {
  shopping: {
    nav: {
      title: 'Zakupy',
    },
    lists: {
      title: 'Listy zakupów',
      subtitle: 'Współdzielone listy Twojej rodziny',
      create: 'Nowa lista',
      namePlaceholder: 'Nazwa listy (np. Dom, Weekend)',
      namePlaceholderShort: 'Nazwa listy',
      createTitle: 'Nowa lista zakupów',
      empty: 'Brak list zakupów. Utwórz pierwszą.',
      items: 'poz.',
      open: 'Otwórz',
      delete: 'Usuń listę',
      deleteConfirm: 'Usunąć tę listę?',
    },
    list: {
      keepSync: {
        create: 'Sync z Google Keep',
        menu: 'Google Keep',
        syncNow: 'Synchronizuj teraz',
        autoSync: 'Automatyczna synchronizacja',
        unlink: 'Odłącz od Keep',
        synced: 'Zsynchronizowano z Keep o {time}',
        error: 'Ostatnia synchronizacja z Keep nie powiodła się',
      },
      back: 'Wróć do list',
      addProduct: 'Dodaj produkt',
      searchPlaceholder: 'Szukaj lub wpisz produkt…',
      searching: 'Szukam…',
      recentSuggestions: 'Ostatnie',
      popularSuggestions: 'Popularne',
      moreOptions: 'Ilość, jednostka i kategoria',
      quickAddPlaceholder: 'np. „2 kg mąki" lub „szklanka cukru"',
      quickAddLabel: 'Szybkie dodawanie z tekstu',
      quickAdd: 'Parsuj',
      add: 'Dodaj',
      addCategory: 'Przypisz kategorię',
      nameExample: 'mąka',
      quantityExample: '500',
      summationHint: 'Ten sam składnik z ilością i jednostką sumuje się automatycznie (np. 1 szklanka mąki + 130 g).',
      empty: 'Ta lista jest pusta. Dodaj pierwszą pozycję.',
      remaining: 'do kupienia',
      checked: 'odhaczone',
      uncategorized: 'Bez kategorii',
      namePlaceholder: 'Nazwa pozycji',
      quantity: 'Ilość',
      unit: 'Jednostka',
      category: 'Kategoria',
      noUnit: 'Bez jednostki',
      noCategory: 'Bez kategorii',
      detectedCategory: 'Kategoria: {category}',
      incrementQuantity: 'Zwiększ ilość',
      decrementQuantity: 'Zmniejsz ilość',
      summed: 'Σ',
      summedHint: 'Pozycja zsumowana z rozpoznanego składnika',
      rename: 'Zmień nazwę',
      save: 'Zapisz',
      cancel: 'Anuluj',
      filterPlaceholder: 'Filtruj pozycje…',
      groupByCategory: 'Grupuj wg kategorii',
      sortBy: 'Sortuj',
      sortCategory: 'Wg kategorii',
      sortName: 'A–Z',
      sortCheckedLast: 'Niewykonane na górze',
      noMatches: 'Brak pozycji pasujących do filtra.',
    },
    categories: {
      title: 'Kategorie',
      description: 'Edytowalne kategorie Twojej rodziny',
      manage: 'Zarządzaj kategoriami',
      namePlaceholder: 'Nazwa kategorii',
      add: 'Dodaj kategorię',
      empty: 'Brak kategorii',
      delete: 'Usuń',
      save: 'Zapisz',
      cancel: 'Anuluj',
      done: 'Gotowe',
    },
    toasts: {
      listCreated: 'Lista utworzona',
      listRenamed: 'Nazwa listy zmieniona',
      listDeleted: 'Lista usunięta',
      listError: 'Coś poszło nie tak z listą',
      itemDeleted: 'Pozycja usunięta',
      itemError: 'Coś poszło nie tak z pozycją',
      categorySaved: 'Kategoria zapisana',
      categoryDeleted: 'Kategoria usunięta',
      categoryError: 'Coś poszło nie tak z kategorią',
    },
  },
}
